<mat-slide-toggle
  [checked]="(defaultCashierCoin$ | async)?.id === '2'"
  (change)="toggleCoin()"
>
  {{ selectedSymbol$ | async }}
</mat-slide-toggle>
